import PageHeader from '@/components/feature/PageHeader';
import { Link } from 'react-router-dom';
import { plotSections, storyOverview } from '@/mocks/plot';
import { usePageMeta } from '@/hooks/usePageMeta';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      name: '泡在我家的辣妹漫画剧情介绍与故事主线',
      inLanguage: 'zh-CN',
      isPartOf: { '@type': 'WebSite', name: '泡在我家的辣妹资料站' },
    },
    {
      '@type': 'Article',
      headline: '泡在我家的辣妹漫画剧情介绍与故事主线',
      description: '泡在我家的辣妹故事讲什么？这里汇总漫画剧情主线、核心设定与分集走向。',
      inLanguage: 'zh-CN',
      about: ['泡在我家的辣妹', '漫画剧情', '故事主线', '核心设定'],
    },
  ],
};

export default function Plot() {
  usePageMeta({
    title: '泡在我家的辣妹漫画剧情介绍 - 故事主线与核心设定',
    description:
      '泡在我家的辣妹漫画剧情到底讲了什么？本文完整介绍泡在我家的辣妹故事主线、核心设定与分集剧情走向，看漫画前先补课。',
    keywords:
      '泡在我家的辣妹漫画剧情,泡在我家的辣妹故事,泡在我家的辣妹讲什么,泡在我家的辣妹剧情介绍,泡在我家的辣妹主线',
    canonicalPath: '/plot',
    ogType: 'article',
    jsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="剧情介绍"
        icon="ri-book-open-line"
        title="泡在我家的辣妹漫画剧情介绍"
        description="从「寄居」的缘起，到日常的磨合，再到心意的坦白——完整梳理《泡在我家的辣妹》的故事主线与核心设定，帮你快速抓住剧情脉络。"
        breadcrumbs={[{ label: '首页', to: '/' }, { label: '剧情介绍' }]}
      />

      <section className="bg-background-50 py-14 md:py-16">
        <div className="container-site">
          <article className="prose-heading mx-auto max-w-3xl">
            <h2 className="font-heading text-xl md:text-2xl">故事到底讲了什么？</h2>
            <div className="mt-5 space-y-5">
              {storyOverview.map((p, i) => (
                <p key={i} className="text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
                  {p}
                </p>
              ))}
            </div>
          </article>

          <div className="mt-14 space-y-10">
            {plotSections.map((sec, idx) => (
              <div
                key={sec.id}
                className="grid grid-cols-1 gap-6 rounded-lg border border-background-200 bg-background-100 p-6 md:gap-10 md:p-8 lg:grid-cols-5"
              >
                <div className="lg:col-span-2">
                  <div className="flex items-center gap-3">
                    <span
                      className={`flex h-12 w-12 items-center justify-center rounded-full text-background-50 ${
                        idx % 2 === 0 ? 'bg-primary-500' : 'bg-accent-500'
                      }`}
                    >
                      <i className={`${sec.icon} text-xl`} />
                    </span>
                    <span className="font-heading text-3xl text-background-300">
                      0{idx + 1}
                    </span>
                  </div>
                  <h2 className="mt-4 font-heading text-xl md:text-2xl">{sec.title}</h2>
                </div>
                <div className="space-y-4 lg:col-span-3">
                  {sec.body.map((text, j) => (
                    <p key={j} className="text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
                      {text}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 flex flex-col items-center gap-4 rounded-lg bg-secondary-100 p-8 text-center md:p-10">
            <h2 className="font-heading text-xl md:text-2xl">剧情脉络已经理清，继续深入了解</h2>
            <p className="max-w-xl text-sm leading-7 text-foreground-700">
              认识推动故事的主要角色，或直接翻到分集剧情，逐话回顾关键情节。
            </p>
            <div className="flex flex-col items-center gap-3 sm:flex-row">
              <Link
                to="/characters"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                查看角色设定
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/episodes"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 bg-background-50 px-7 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer"
              >
                浏览分集剧情
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}